/* eslint-disable import/no-anonymous-default-export */

import Typography from '@mui/material/Typography';

export default (props) => <Typography {...props}>{props.children}</Typography>;
